import { render, staticRenderFns } from "./TourTaxi.vue?vue&type=template&id=443feaf2&scoped=true"
import script from "./TourTaxi.vue?vue&type=script&lang=js"
export * from "./TourTaxi.vue?vue&type=script&lang=js"
import style0 from "./TourTaxi.vue?vue&type=style&index=0&id=443feaf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443feaf2",
  null
  
)

export default component.exports